// extracted by mini-css-extract-plugin
module.exports = {"menu":"MobileMenu_menu__32JQl index_flex__3nqeG index_flex-column__2sh2c index_absolute__2gTIb index_top-0__15s-Z index_bottom-0__clwCB index_pa3__3k1QZ"};